import { Box } from '@mui/material';
import { blue, green, red } from '@mui/material/colors';
import { format } from 'date-fns';
import _ from 'lodash';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

class CustomTooltip extends React.Component {
  render() {
    const { active } = this.props;

    if (active) {
      const { payload, label } = this.props;
      const readings = _.map(payload, value => (
        <p className="desc" key={value.name} style={{ color: value.stroke }}>
          {value.name}: {value.value}
        </p>
      ));
      return (
        <Box
          className="custom-tooltip"
          sx={{
            bgcolor: 'background.paper',
            color: 'text.primary',
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 1,
          }}
        >
          <p className="label">{`${format(payload[0].payload.moment, 'P')}`}</p>
          {readings}
        </Box>
      );
    }

    return null;
  }
}

/** unused, leaving for potential later implementation * */
class CustomizedLabel extends React.Component {
  render() {
    const { x, y, stroke, value } = this.props;

    return (
      <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
        {value}
      </text>
    );
  }
}

class CustomizedAxisTick extends React.Component {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="var(--text-secondary)" transform="rotate(-35)">
          {payload.value}
        </text>
      </g>
    );
  }
}

class SolarPowerChart extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { list } = this.props;
    // do not rerender the chart unless the list actually changes.
    return !_.isEqual(list, nextProps.list);
  }

  render() {
    const { list, t } = this.props;

    if (list.length > 0) {
      return (
        <ResponsiveContainer height={400}>
          <LineChart
            data={list}
            margin={{
              top: 15,
              right: 30,
              left: 0,
              bottom: 15,
            }}
          >
            <XAxis dataKey="short" tick={<CustomizedAxisTick />} axisLine={{ stroke: 'var(--divider-color)' }} />
            <YAxis tick={{ fill: 'var(--text-secondary)' }} axisLine={{ stroke: 'var(--divider-color)' }} />
            <CartesianGrid strokeDasharray="3 3" stroke="var(--divider-color)" />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ paddingTop: 20 }} />
            <Line
              name={t('powerData.generatedKwh', 'Generated (kWh)')}
              type="monotone"
              dataKey="generated"
              stroke={green[500]}
              dot={{ stroke: green[500], strokeWidth: 2 }}
              activeDot={{ r: 8 }}
            />
            <Line
              name={t('powerData.consumedKwh', 'Consumed (kWh)')}
              type="monotone"
              dataKey="consumed"
              stroke={red[400]}
              dot={{ stroke: red[400], strokeWidth: 2 }}
              activeDot={{ r: 8 }}
            />
            <Line
              name={t('powerData.netEnergyKwh', 'Net Energy (kWh)')}
              type="monotone"
              dataKey="net"
              stroke={blue[500]}
              dot={{ stroke: blue[500], strokeWidth: 2 }}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      );
    }

    return (
      <div style={{ height: '400px', padding: '50px' }}>
        <h5 style={{ textAlign: 'center', color: blue[500] }}>{t('sites.noReadingsFound', 'No readings found.')}</h5>
        <h5 style={{ textAlign: 'center', color: blue[500] }}>
          {t('sites.tryWiderDateRange', 'Try a wider date range.')}
        </h5>
      </div>
    );
  }
}

export default withTranslation()(SolarPowerChart);
